export const regexEditSuccess = /^@store\/(.*)\/EDIT_FETCH_SUCCEEDED$/

export const regexCreateSuccess = /^@store\/(.*)\/CREATE_FETCH_SUCCEEDED$/
